import React from 'react';

import { Animation } from 'components/lottie-animations/order-confirmation';

export default ({ isPaused = false }) => <Animation isPaused={isPaused} />;
